import History from '@fhs-legacy/frontend/src/pages/account/history';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function HistoryPage() {
  return <History />;
}
